import { BaseApi } from './BaseAPI';

const baseURL = 'telemetry/reports/';

export interface TelemetryCountsByDayRow {
	type: string;
	total: number;
	date: string;
}

export interface TelemetryTargetsByDayRow {
	date: string;
	target: string;
	total: number;
}

interface TelemetryByDayParams {
	startDate: string;
	endDate: string;
	distinct: boolean;
	noAnon: boolean;
}

interface TelemetryTargetsByDayParams extends TelemetryByDayParams {
	type: string;
}

export const TelemetryApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		getTelemetryCountsByDay: builder.query<TelemetryCountsByDayRow[], TelemetryByDayParams>({
			query: ({ startDate, endDate, distinct, noAnon }) => ({
				url: `${baseURL}telemetryCountsByDay/${startDate}/${endDate}/${distinct}/${noAnon}`,
				method: 'GET'
			}),
			providesTags: (result, error, arg) =>
				result?.map(({ type }) => ({ type: 'Telemetry', id: `type:${type}` })) ?? []
		}),
		getTelemetryTargetsByDay: builder.query<TelemetryTargetsByDayRow[], TelemetryTargetsByDayParams>({
			query: ({ startDate, endDate, type, distinct, noAnon }) => ({
				url: `${baseURL}telemetryTargetsByDay/${type}/${startDate}/${endDate}/${distinct}/${noAnon}`,
				method: 'GET'
			}),
			providesTags: (result, error, arg) =>
				result?.map(({ target }) => ({ type: 'Telemetry', id: `target:${target}` })) ?? []
		})
	})
});

export const { useGetTelemetryCountsByDayQuery, useGetTelemetryTargetsByDayQuery } = TelemetryApi;
